'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import CommentsPanel from '@/app/[locale]/(worlds)/[roomId]/components/CommentsPanel';
import MobileCommentsDrawer from '@/app/[locale]/(worlds)/[roomId]/components/MobileCommentsDrawer';
import MobileCommentsTrigger from '@/app/[locale]/(worlds)/[roomId]/components/MobileCommentsTrigger';
function MobileComments() {
  const $ = _c(4);
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MobileCommentsTrigger onClick={() => setOpen(true)} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CommentsPanel variant="drawer" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== open) {
    t2 = <>{t0}<MobileCommentsDrawer open={open} onOpenChange={setOpen}>{t1}</MobileCommentsDrawer></>;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export default MobileComments;